/* eslint-disable no-param-reassign */
import { type PayloadAction, type Slice, createSlice } from "@reduxjs/toolkit"
import reject from "lodash-es/reject"

import type { IRootState } from "../store"

enum EModalId {
    // unused
    AnalyticsDashboard = "AnalyticsDashBoard",
    // participant-only
    Participant_SessionAttendance = "Participant_SessionAttendance",
    Participant_CoachingChatAbandonment = "Participant_CoachingChatAbandonment",
    Participant_CoachingChatGuide = "Participant_CoachingChatGuide",
    Participant_CoachingChatMatrixFeedback = "Participant_CoachingChatMatrixFeedback",
    Participant_ChapterRequiredComponents = "Participant_ChapterRequiredComponents",
    Participant_ModulePhasePractice = "Participant_ModulePhasePractice",
    _Legacy_Participant_LoginVerification = "_Legacy_Participant_LoginVerification",
    _Legacy_Participant_Sso = "_Legacy_Participant_Sso",
    Coach_SkipLinkingAccounts = "Coach_SkilLinkingAccounts",
    Coach_AccountDeactivation = "Coach_AccountDeactivation",
    Coach_GiftSession = "Coach_GiftSession",
    // coach-only
    Coach_GiftedSession = "Coach_GiftedSession",
    _Legacy_Coach_SetupSchedule = "_Legacy_Coach_SetupSchedule",
    // shared
    Feedback = "Feedback",
    ReloadApp = "reloadApp",
    PostSession = "PostSession",
    ScheduleSession = "ScheduleSession",
    ScheduleAvailableSessions = "ScheduleAvailableSessions",
    DiagnosticSummary = "DiagnosticSummary",
    Attendance = "Attendance",
    AttendanceEarly = "AttendanceEarly",
    CancelSession = "CancelSession",
    LateEditSession = "LateEditSession",
    CancelledSession = "CancelledSession",
    SessionReschedules = "SessionReschedules",
    _LegacyResetPassword = "_LegacyResetPassword"
}

type TModalProps<TIncomingProps extends Record<string, unknown> = {}> = TIncomingProps

interface IModal<T = TModalProps> {
    id: EModalId
    isOpen: boolean
    props?: T
    instanceKey: number
}

interface IModalState {
    modals: IModal[]
}

const MODAL_REDUCER_NAME: string = "modal"

const initialState: IModalState = {
    modals: []
}

const slice: Slice = createSlice({
    name: MODAL_REDUCER_NAME,
    initialState,
    reducers: {
        showModal({ modals }: IRootState, { payload: { id, props } }: PayloadAction<IModal>): void {
            modals.push({
                id,
                isOpen: true,
                instanceKey: Date.now(),
                props
            })
        },
        hideModal(state: IRootState, action: PayloadAction<{ id: EModalId }>): void {
            state.modals = reject<IModal>(state.modals, { id: action.payload.id })
        },
        refreshModal: (state: IRootState, { payload: { id, props } }: PayloadAction<IModal>): void => {
            state.modals = reject<IModal>(state.modals, { id })

            state.modals.push({ id, isOpen: true, instanceKey: Date.now(), props })
        }
    }
})

const { reducer: modalReducer, actions: modalReducerActions }: Slice = slice

export { modalReducerActions, modalReducer, MODAL_REDUCER_NAME }
export { type IModal, type TModalProps, EModalId }
